/* eslint-disable eqeqeq */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import BusinessActivityNewPermit from './BusinessActivityNewPermit';
import BusinessPermitRenewPermit from './BusinessPermitRenewPermit';
import * as actions from '../action';
import * as c from '../constant';

function BusinessActivity({
  data, lineBusinessList,
  mode, handleMode, permitType,
  formSubmit, setFormData, formData,
  handleChangeInput, handleChangeSelect, handleChangeNature,
  transactionStatus,
}) {
  const handleCancel = () => {
    setFormData(data);
    handleMode(0, 'BA');
  };

  const handleSubmit = () => {
    formSubmit(formData, 'BUSINESS');
  };

  const handleFilterLineBusinessInfo = (lineBusinessId) => {
    const target = lineBusinessList.filter(item => _.get(item, 'id') == lineBusinessId);
    const natureList = _.get(target, '0.included.natureBusinesses') || [];
    const choices = natureList.map(item => ({ label: _.get(item, 'attributes.name'), value: _.get(item, 'id') }));
    return choices;
  };

  const handleFilterMayorFee = (lineBusinessId, natureId) => {
    const target = lineBusinessList.filter(item => _.get(item, 'id') == lineBusinessId);
    const natureList = _.get(target, '0.included.natureBusinesses') || [];
    const selectedNature = natureList.find(item => +natureId === +item.id);
    const choices = [
      {
        id: 1,
        label: _.get(selectedNature, 'attributes.fix_amount') || 50,
        value: _.get(selectedNature, 'attributes.fix_amount') || 50,
      },
      {
        id: 2,
        label: _.get(selectedNature, 'attributes.small_category') || 100,
        value: _.get(selectedNature, 'attributes.small_category') || 100,
      },
      {
        id: 3,
        label: _.get(selectedNature, 'attributes.medium_category') || 150,
        value: _.get(selectedNature, 'attributes.medium_category') || 150,
      },
      {
        id: 4,
        label: _.get(selectedNature, 'attributes.large_category') || 200,
        value: _.get(selectedNature, 'attributes.large_category') || 200,
      },
    ];
    return choices;
  };

  const handlePermitType = () => {
    switch (permitType) {
      case 'RENEW':
        return (
          <BusinessPermitRenewPermit
            handleFilterLineBusinessInfo={handleFilterLineBusinessInfo}
            handleFilterMayorFee={handleFilterMayorFee}
            data={data}
            mode={mode}
            handleChangeInput={handleChangeInput}
            handleChangeSelect={handleChangeSelect}
            formData={formData}
          />
        );
      default:
        return (
          <BusinessActivityNewPermit
            handleFilterLineBusinessInfo={handleFilterLineBusinessInfo}
            handleFilterMayorFee={handleFilterMayorFee}
            handleChangeNature={handleChangeNature}
            data={data}
            mode={mode}
            handleChangeInput={handleChangeInput}
            handleChangeSelect={handleChangeSelect}
            formData={formData}
          />
        );
    }
  };

  return (
    <React.Fragment>
      <div className="row mb-3 d-flex align-items-center">
        <div className="col py-0">
          <h3 className="m-0">Business Activity</h3>
        </div>
        <div className="col py-0 m-0 d-flex">
          {transactionStatus === 'FOR APPEARANCE' ? (
            <React.Fragment>
              {mode.businessActivity === 0 ? (
                <button
                  type="button"
                  onClick={() => (handleMode(1, 'BA'))}
                  className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto"
                >
                  Edit<i className="far fa-edit icon-edit p-0 ml-1" />
                </button>
              ) : (
                <React.Fragment>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 mr-2 ml-auto"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="btn btn-secondary btn-round font-weight-bold px-4"
                  >
                    Cancel
                  </button>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : ''}
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12 pb-3">
          <div className="table-wrapper">
            {handlePermitType()}
          </div>
        </div>
      </div>

      {/* COMPUTATION */}
      <div className="container-fluid card-section-content">
        <div className="d-flex">
          <div className="col" />
          <div className="col-4 py-0 d-flex">
            <h3 className="mr-3">Total Mayor`s Fee:</h3>
          </div>
          <div className="col-2">
            <h3 className="text-primary">{_.sum(formData.map(x => _.get(x, 'mayors_fee_label', 0)), 0)}</h3>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

BusinessActivity.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  permitType: PropTypes.string.isRequired,
  mode: PropTypes.instanceOf(Object).isRequired,
  handleMode: PropTypes.instanceOf(Function).isRequired,

  handleChangeInput: PropTypes.instanceOf(Function).isRequired,
  handleChangeSelect: PropTypes.instanceOf(Function).isRequired,
  handleChangeNature: PropTypes.instanceOf(Function).isRequired,

  formSubmit: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  lineBusinessList: PropTypes.instanceOf(Array).isRequired,

  transactionStatus: PropTypes.string,
};

BusinessActivity.defaultProps = {
  transactionStatus: '',
};

const mapStateToProps = ({ api }) => ({
  lineBusinessList: _.get(api, `${c.GET_LINE_BUSINESS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(BusinessActivity);
